/* DESCENA ds-core.js — Scroll-Reveal + Sticky-ATC. Kein Framework, ~2 KB.
   Respektiert prefers-reduced-motion; no-JS-Fallback via html.ds-js (CSS). */
(function () {
  'use strict';
  document.documentElement.classList.add('ds-js');

  function initReveal() {
    var els = document.querySelectorAll('.ds-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Sticky-ATC: erscheint, sobald die Buy-Buttons der PDP aus dem Viewport
     gescrollt sind; verschwindet, wenn sie wieder sichtbar sind oder der
     Footer erreicht wird. Klick delegiert an den echten Produkt-Form-Submit
     (ein Formular, eine Wahrheit — keine doppelte Cart-Logik). */
  function initStickyAtc() {
    var bar = document.querySelector('.ds-satc');
    if (!bar) return;
    var buyBox = document.querySelector('.product-form__buttons') || document.querySelector('product-form');
    if (!buyBox || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var below = entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-active', !entry.isIntersecting && below);
      });
    }, { threshold: 0 });
    io.observe(buyBox);

    var btn = bar.querySelector('[data-ds-satc-submit]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        var realBtn = document.querySelector('.product-form__buttons [type="submit"], .product-form__submit');
        if (realBtn && !realBtn.disabled) {
          e.preventDefault();
          realBtn.click();
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          realBtn.closest('form') && realBtn.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        }
        /* Fallback: Button ist ein <a href="#buybox"> und springt dorthin. */
      });
    }
  }

  /* Ambient-Videos (.ds-video): autoplay nur im Viewport, Pause außerhalb.
     prefers-reduced-motion: nie abspielen (Poster bleibt stehen).
     data-rate="0.85" verlangsamt cineastisch. Kein Ton, keine Controls. */
  function initVideos() {
    var vids = document.querySelectorAll('video.ds-video');
    if (!vids.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    vids.forEach(function (v) {
      v.removeAttribute('autoplay');
      var rate = parseFloat(v.getAttribute('data-rate'));
      if (rate && rate > 0) { v.defaultPlaybackRate = rate; v.playbackRate = rate; }
      v.pause();
    });
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: [0, 0.25, 0.6] });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* Produktmontage: Das stumme Originalprodukt-Video folgt dem Scrollfortschritt.
     Kein Autoplay. Ohne JS oder bei reduced-motion bleibt die kompakte Posteransicht.
     Kurze 170–220-vh-Strecke statt langem Scroll-Hijacking. */
  function initScrubAssembly() {
    var roots = document.querySelectorAll('[data-ds-scrub]');
    if (!roots.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function (root) {
      if (root.getAttribute('data-ds-scrub-ready') === 'true') return;
      root.setAttribute('data-ds-scrub-ready', 'true');

      var video = root.querySelector('[data-ds-scrub-video]');
      var progress = root.querySelector('[data-ds-scrub-progress]');
      var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-ds-scrub-chapter]'));
      var startTrim = parseFloat(root.getAttribute('data-start-trim')) || 0;
      var endTrim = parseFloat(root.getAttribute('data-end-trim')) || 0;
      if (!video || reduce) return;

      root.classList.add('is-enhanced');
      video.pause();
      var duration = 0;
      var active = true;
      var raf = window.requestAnimationFrame || function (fn) { return window.setTimeout(fn, 16); };
      /* Passendes cancel zum jeweiligen raf — clearTimeout, wenn der Fallback greift. */
      var cancelRaf = window.requestAnimationFrame
        ? (window.cancelAnimationFrame || function () {})
        : function (id) { window.clearTimeout(id); };
      var rafId = 0;

      function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }

      function setChapter(percent) {
        var current = 0;
        chapters.forEach(function (chapter, index) {
          var start = parseFloat(chapter.getAttribute('data-start')) || 0;
          if (percent >= start) current = index;
        });
        chapters.forEach(function (chapter, index) {
          chapter.classList.toggle('is-current', index === current);
        });
      }

      function update() {
        rafId = 0;
        if (!active) return;
        var rect = root.getBoundingClientRect();
        var distance = Math.max(1, root.offsetHeight - window.innerHeight);
        var ratio = clamp(-rect.top / distance, 0, 1);
        if (progress) progress.style.transform = 'scaleX(' + ratio.toFixed(4) + ')';
        setChapter(ratio * 100);

        var mediaDuration = isFinite(video.duration) ? video.duration : duration;
        if (mediaDuration > 0) {
          var playableDuration = Math.max(0.1, mediaDuration - startTrim - endTrim);
          var target = Math.min(mediaDuration - endTrim, startTrim + ratio * playableDuration);
          if (Math.abs(video.currentTime - target) > 0.025) {
            try { video.currentTime = target; } catch (e) {}
          }
        }
      }

      function requestUpdate() {
        /* Selbstheilend: einen haengenden Frame verwerfen und neu anfordern.
           Das alte Einweg-Flag blieb haengen, wenn der rAF-Callback nie kam
           (Hintergrund-Tab oder verdecktes Fenster) — danach war die Sektion
           bis zum Reload tot. */
        if (rafId) cancelRaf(rafId);
        rafId = raf(update);
      }

      function revive() {
        if (rafId) { cancelRaf(rafId); rafId = 0; }
        update();
      }

      var metaBereit = false;
      function ready() {
        if (metaBereit) return;
        metaBereit = true;
        duration = isFinite(video.duration) ? video.duration : 0;
        video.pause();
        if (video.currentTime < startTrim) {
          try { video.currentTime = startTrim; } catch (e) {}
        }
        requestUpdate();
      }

      video.addEventListener('loadedmetadata', ready);
      video.addEventListener('loadeddata', ready);
      video.addEventListener('durationchange', ready);
      /* visibilitychange allein reicht nicht: bei bloss verdecktem Fenster bleibt
         visibilityState 'visible', waehrend rAF trotzdem gedrosselt wird. */
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') revive();
      });
      window.addEventListener('focus', revive);
      window.addEventListener('pageshow', revive);
      /* Video erst kurz vor Erreichen der Sektion laden (Poster bis dahin) */
      var videoAngefordert = false;
      function ladeVideo() {
        if (videoAngefordert) return;
        videoAngefordert = true;
        video.preload = 'auto';
        video.load();
      }
      if (video.readyState >= 1) ready();

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            active = entry.isIntersecting;
            if (active) { ladeVideo(); requestUpdate(); }
          });
        }, { rootMargin: '80% 0px 80% 0px', threshold: 0 });
        observer.observe(root);
        var lader = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { lader.disconnect(); ladeVideo(); }
        }, { rootMargin: '200% 0px 200% 0px', threshold: 0 });
        lader.observe(root);
      } else {
        ladeVideo();
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      requestUpdate();
    });
  }

  /* Wasserbedarfsrechner: Herdengröße → täglicher Planungsbedarf (0,25–0,33 l je Huhn
     und Tag, Riek et al. 2021) → nötiges Fassungsvermögen mit Reserve. Bewusst OHNE
     Standtage-/Reichweitenaussage über die Tränke (Kapazitätsregel claims.md).
     Server-gerenderte Defaults bleiben ohne JS gültig. Umgestellt 10.08.2026. */
  function initRechner() {
    var root = document.querySelector('[data-ds-rechner]');
    if (!root) return;
    var input = root.querySelector('[data-ds-r-input]');
    var count = root.querySelector('[data-ds-r-count]');
    var days = root.querySelector('[data-ds-r-days]');
    var verdict = root.querySelector('[data-ds-r-verdict]');
    if (!input || !days) return;

    function eine(x) { return Math.round(x * 10) / 10; }
    function fmt(x) { return ('' + x).replace('.', ','); }

    function update() {
      var n = parseInt(input.value, 10) || 1;
      if (count) count.textContent = n >= 20 ? '20+' : n;
      var lo = eine(0.25 * n);
      var hi = eine(0.33 * n);
      var vol = Math.max(1, Math.ceil(hi * 1.5));
      var fill = ((n - 1) / 19) * 100;
      input.style.setProperty('--ds-r-fill', fill + '%');
      input.setAttribute('aria-valuetext', (n >= 20 ? '20 oder mehr' : n) + ' Hühner');

      days.textContent = 'ca. ' + fmt(lo) + ' bis ' + fmt(hi) + ' Liter pro Tag';
      if (verdict) {
        verdict.textContent = 'Mit Reserve rund ' + vol + ' Liter Fassungsvermögen'
          + (n >= 20 ? ' (ab 20 Hühnern entsprechend mehr)' : '')
          + '. Wasserstand täglich prüfen.';
      }
    }
    input.addEventListener('input', update);
    update();
  }

  function init() { initReveal(); initStickyAtc(); initVideos(); initScrubAssembly(); initRechner(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', initScrubAssembly);
})();
